import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Viewer from '@/components/Viewer'
import Login from '@/components/Login'

import firebase from 'firebase';

Vue.use(Router)

let router = new Router({
  routes: [
    /*{
      path: '*',
      redirect: '/login'
    },*/
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: "Login",
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/viewer/:id',
      name: 'Viewer',
      component: Viewer,
      meta: {
        requiresAuth: true
      }
    }
  ]
});
/*router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some( record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if(requiresAuth && currentUser){
    next()
    console.log(to, from, next);
  }
})*/

/*router.beforeEach( (to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some( record => record.meta.requiresAuth);

  if(requiresAuth && !currentUser) next('Login')
  else if(!requiresAuth && currentUser) next('Dashboard')
  else next()
  
 
} );*/

export default router



// WEBPACK FOOTER //
// ./src/router/index.js